"use strict";

var BaseCollection = require('./baseCollection');
var ContactRequest = require('./contactRequest');

module.exports = BaseCollection.extend({
    type: 'contactRequests',
    model: ContactRequest
});


//////////////////
// WEBPACK FOOTER
// ./models/contactRequests.js
// module id = 796
// module chunks = 2